// Calcula o grau de inovação de uma dimensão
export const calcularGI = (dimensão) => {
	return (
		Object.values(dimensão).reduce(function (a, b) {
			return a + b;
		}, 0) / Object.keys(dimensão).length
	);
};

// Calcular Grau de Inovação Geral
// Retorna dois valores: 
// um float (para classificar o grau de inovação) e uma string (exibição)
export const calcularGrauDeInovacaoGeral = (emi, ggpi, aio, igc, pg) => {
	let dim = [];
	let total = 0;

	dim.push(emi);
	dim.push(ggpi);
	dim.push(aio);
	dim.push(igc);
	dim.push(pg);

	for (let d of dim) {
		for (let value of Object.values(d)) {
			total += value;
		}
	}

	total =
		parseFloat(total) /
		(Object.keys(emi).length +
			Object.keys(ggpi).length +
			Object.keys(aio).length +
			Object.keys(igc).length +
			Object.keys(pg).length);

	return {
        'float': total, 
        'string': total.toPrecision(2).toString().replace(".", ",")
    };
};

// Classifica a Organização de acordo com
// o valor do Grau de Inovação
export const classificarOrganizacao = (grauDeInovaçãoGeral) => {
	let classificação = "";

	switch (true) {
		case grauDeInovaçãoGeral >= 4:
			classificação = "Inovadora Sistêmica";
			break;
		case grauDeInovaçãoGeral >= 3 && grauDeInovaçãoGeral < 4:
			classificação = "Inovadora Ocasional";
			break;
		case grauDeInovaçãoGeral > 1 && grauDeInovaçãoGeral < 3:
			classificação = "Pouco Inovadora";
			break;
		case grauDeInovaçãoGeral === 1:
			classificação = "Não Inovadora";
			break;
		default:
	}

	return classificação;
};

// Grau para cada Dimensão
// Necessário para o Gráfico de Teia
// O vetor é adaptado de acordo com a biblioteca do Gráfico de Teia
export const grauDeInovaçãoDeCadaDimensão = (emi, ggpi, aio, igc, pg) => {
	const dimensõesGI = [];

	dimensõesGI.push({
		name: ["Estratégias Metodológicas", "para Inovação"],
		value: emi.toPrecision(3),
	});
	dimensõesGI.push({
		name: ["Geração e Gestão", "da Propriedade Intelectual"],
		value: ggpi.toPrecision(3),
	});
	dimensõesGI.push({
		name: ["Ações de Inovação", "Organizacional"],
		value: aio.toPrecision(3),
	});
	dimensõesGI.push({
		name: ["Investimento para", "Geração de Conhecimento"],
		value: igc.toPrecision(3),
	});
	dimensõesGI.push({
		name: "Perfil do Gestor",
		value: pg.toPrecision(3),
	});

	return dimensõesGI;
};
